module.exports = __webpack_public_path__ + "img/logo-96.0548d557.webp";